"use strict";

exports.__esModule = true;
exports.CrossChainRouterManager = void 0;
var _chains = require("./configs/chains");
var _isChainEqual = require("./utils/is-chain-equal");
var _lodash = require("lodash");
class CrossChainRouterManager {
  constructor(configs) {
    this.routers = void 0;
    this.adapters = void 0;
    this.routers = [];
    this.adapters = (configs === null || configs === void 0 ? void 0 : configs.adapters) || [];
  }
  findAdapterByName(chain) {
    return this.adapters.find(i => (0, _isChainEqual.isChainEqual)(chain, i.chain));
  }
  async addRouter(router, checkAdapter) {
    if (checkAdapter === void 0) {
      checkAdapter = true;
    }
    const {
      token
    } = router;
    const from = typeof router.from === 'string' ? _chains.chains[router.from] : router.from;
    const to = typeof router.to === 'string' ? _chains.chains[router.to] : router.to;

    // push routers if from & to adapters are both set
    if (!checkAdapter || this.findAdapterByName(from) && this.findAdapterByName(to) && checkAdapter) {
      this.routers.push({
        from,
        to,
        token
      });
    }
  }
  async addRouters(routers, checkAdapter) {
    if (checkAdapter === void 0) {
      checkAdapter = true;
    }
    await Promise.all(routers.map(i => this.addRouter(i, checkAdapter)));
  }
  getRouters(params) {
    // return all router configs when params is empty
    if (!params || (0, _lodash.isEmpty)(params)) return this.routers;
    const compares = (0, _lodash.overEvery)(Object.entries(params).map(_ref => {
      let [k, v] = _ref;
      switch (k) {
        case 'from':
          return i => (0, _isChainEqual.isChainEqual)(i.from, v);
        case 'to':
          return i => (0, _isChainEqual.isChainEqual)(i.to, v);
        case 'token':
          {
            return i => i.token === v;
          }
      }
      return undefined;
    }).filter(i => !!i));
    return this.routers.filter(i => compares(i));
  }
  getDestiantionsChains(params) {
    if ((0, _lodash.isEmpty)(params)) return [];
    return (0, _lodash.uniqWith)(this.getRouters(params).map(i => i.to), (i, j) => (0, _isChainEqual.isChainEqual)(i, j));
  }
  getFromChains(params) {
    if ((0, _lodash.isEmpty)(params)) return [];
    return (0, _lodash.uniqWith)(this.getRouters(params).map(i => i.from), (i, j) => (0, _isChainEqual.isChainEqual)(i, j));
  }
  getAvailableTokens(params) {
    if ((0, _lodash.isEmpty)(params)) return [];
    return (0, _lodash.uniqWith)(this.getRouters(params).map(i => i.token), (i, j) => i === j);
  }
}
exports.CrossChainRouterManager = CrossChainRouterManager;